import React, { useState } from 'react';

const BackgroundCheckStep = ({ data, onChange, onNext, onBack }) => {
  const [expanded, setExpanded] = useState(false);

  const handleConsent = (value) => {
    onChange('backgroundCheckConsent', value);
  };

  return (
    <div className="max-w-lg mx-auto">
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-2" style={{ color: '#0a1628' }}>
          Background Check
        </h2>
        <p className="text-gray-500 text-sm">
          To ensure the safety of our customers, all drivers must pass a background check.
        </p>
      </div>
      {/* What We Check */}
      <div className="rounded-2xl p-5 mb-5" style={{ background: '#f8fafc', border: '1px solid #e5e7eb' }}>
        <h3 className="font-bold text-sm mb-4" style={{ color: '#0a1628' }}>
          What We Check
        </h3>
        <div className="space-y-3">
          {[
            { icon: '🚔', title: 'Criminal Record', desc: 'National criminal database check' },
            { icon: '🚗', title: 'Driving History', desc: 'Traffic violations and license validity' },
            { icon: '📋', title: 'Employment History', desc: 'Previous driving service records' },
            { icon: '🔒', title: 'Identity Fraud', desc: 'Document authenticity verification' },
          ]?.map((item) => (
            <div key={item?.title} className="flex items-start gap-3">
              <span className="text-lg flex-shrink-0">{item?.icon}</span>
              <div>
                <p className="font-semibold text-sm" style={{ color: '#0a1628' }}>
                  {item?.title}
                </p>
                <p className="text-xs text-gray-400">{item?.desc}</p>
              </div>
              <div
                className="ml-auto w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(255,215,0,0.2)' }}
              >
                <span className="text-xs" style={{ color: '#f59e0b' }}>✓</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Privacy Policy */}
      <div className="rounded-xl border border-gray-200 mb-5 overflow-hidden">
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
        >
          <span className="font-semibold text-sm" style={{ color: '#0a1628' }}>
            📄 Privacy Policy & Data Usage
          </span>
          <span className="text-gray-400 text-sm">{expanded ? '▲' : '▼'}</span>
        </button>
        {expanded && (
          <div className="px-4 pb-4 text-xs text-gray-500 space-y-2 border-t border-gray-100 pt-3">
            <p>
              OnTheGo collects and processes your personal data for the purpose of conducting background
              checks as required by our driver onboarding process. Your data is handled in accordance
              with the Kenya Data Protection Act, 2019.
            </p>
            <p>
              We partner with licensed background check providers who are bound by strict confidentiality
              agreements. Your data will not be sold or shared with third parties for marketing purposes.
            </p>
            <p>
              Background check results are retained for 2 years from the date of your application. You
              have the right to request access to or deletion of your data at any time by contacting
              privacy@onthego.co.ke.
            </p>
          </div>
        )}
      </div>
      {/* Consent Checkbox */}
      <div
        className="rounded-xl p-4 mb-6 cursor-pointer transition-all duration-200"
        style={{
          background: data?.backgroundCheckConsent ? 'rgba(255,215,0,0.08)' : '#f9fafb',
          border: `2px solid ${data?.backgroundCheckConsent ? '#ffd700' : '#e5e7eb'}`,
        }}
        onClick={() => handleConsent(!data?.backgroundCheckConsent)}
      >
        <div className="flex items-start gap-3">
          <div
            className="w-5 h-5 rounded flex items-center justify-center flex-shrink-0 mt-0.5 transition-all duration-200"
            style={{
              background: data?.backgroundCheckConsent
                ? 'linear-gradient(135deg, #ffd700, #f59e0b)'
                : 'white',
              border: `2px solid ${data?.backgroundCheckConsent ? '#ffd700' : '#d1d5db'}`,
            }}
          >
            {data?.backgroundCheckConsent && (
              <span className="text-xs font-bold" style={{ color: '#0a1628' }}>
                ✓
              </span>
            )}
          </div>
          <p className="text-sm text-gray-700 leading-relaxed">
            I consent to OnTheGo conducting a background check using the information I have provided.
            I understand this is required to become a verified OnTheGo driver and I agree to the{' '}
            <span className="font-semibold" style={{ color: '#f59e0b' }}>
              Privacy Policy
            </span>{' '}
            and{' '}
            <span className="font-semibold" style={{ color: '#f59e0b' }}>
              Terms of Service
            </span>
            .
          </p>
        </div>
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={onBack}
          className="flex-1 py-3.5 rounded-xl font-bold text-sm border-2 transition-all duration-200 hover:bg-gray-50"
          style={{ borderColor: '#0a1628', color: '#0a1628' }}
        >
          ← Back
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={!data?.backgroundCheckConsent}
          className="flex-1 py-3.5 rounded-xl font-bold text-sm transition-all duration-200 hover:opacity-90 active:scale-95 shadow-lg disabled:opacity-40 disabled:cursor-not-allowed"
          style={{ background: 'linear-gradient(135deg, #ffd700, #f59e0b)', color: '#0a1628' }}
        >
          Continue →
        </button>
      </div>
    </div>
  );
};

export default BackgroundCheckStep;
